import { FormControl, FormGroup } from '@angular/forms';
import {
    type AnalyticsSettingsFormGroupType,
    type AnalyticsSettingsFormControls,
    type GoogleSettingsFormType,
    type PixelSettingsFormType,
} from '@common/types/analytics-setings.type';

export const analyticsSettingsFormGroup = (): AnalyticsSettingsFormGroupType =>
    new FormGroup<AnalyticsSettingsFormControls>({
        googleAnalytic: new FormControl(null),
        googleAnalyticAfterPayment: new FormControl(null),
        pixelAnalytic: new FormControl(null),
        pixelAnalyticAfterPayment: new FormControl(null),
        googleSettings: new FormGroup<GoogleSettingsFormType>({
            category: new FormControl(null),
            action: new FormControl(null),
            label: new FormControl(null),
            currency: new FormControl(null),
            value: new FormControl(null),
            leadSource: new FormControl(null),
        }),
        pixelSettings: new FormGroup<PixelSettingsFormType>({
            type: new FormControl(null),
            typeAfterPayment: new FormControl(null),
        }),
    });
